// extracted by mini-css-extract-plugin
export default {"ButtonGroup-actions":"styles_ButtonGroup-actions__979W5","ButtonGroup--center":"styles_ButtonGroup--center__mZ406"};